/* Orgville v2: header, filters, rails, bottom nav, cart pill (21-10-2026) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const html = document.documentElement;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  };

  /* Header height -> --header-h (for sticky bars under the header) */
  const headerWrap = $('.section-header') || $('[data-header]');
  function setHeaderH() {
    if (!headerWrap) return;
    html.style.setProperty('--header-h', Math.round(headerWrap.getBoundingClientRect().height) + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH, { passive: true });
  if (headerWrap && 'ResizeObserver' in window) new ResizeObserver(setHeaderH).observe(headerWrap);

  /* Scroll direction (filter bar hides on scroll down, returns on scroll up) */
  let lastY = window.scrollY;
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      if (Math.abs(y - lastY) > 6) {
        html.classList.toggle('is-scrolling-down', y > lastY && y > 200);
        lastY = y;
      }
      const bar = $('[data-coll-bar]');
      if (bar) bar.classList.toggle('is-stuck', y > 260);
      ticking = false;
    });
  }, { passive: true });

  /* Mega menu: open on hover with a short close delay */
  $$('.nav__item.has-dropdown').forEach((item) => {
    let t;
    const open = () => { clearTimeout(t); $$('.nav__item.is-open').forEach((o) => { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); };
    const close = () => { clearTimeout(t); t = setTimeout(() => item.classList.remove('is-open'), 220); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) item.classList.remove('is-open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.nav__item.is-open').forEach((o) => o.classList.remove('is-open'));
    closeColl(); closeSheets();
    $$('details.filter[open]').forEach((d) => d.removeAttribute('open'));
  });

  /* Collection filters: sidebar collapse (desktop), drawer (tablet/phone) */
  const coll = $('[data-coll]');
  const wide = window.matchMedia('(min-width: 1024px)');
  function closeColl() {
    if (!coll || !coll.classList.contains('is-open')) return;
    coll.classList.remove('is-open');
    const bd = $('.coll__backdrop', coll); if (bd) bd.hidden = true;
    document.body.style.overflow = '';
    syncToggle();
  }
  function syncToggle() {
    if (!coll) return;
    const btn = $('[data-coll-toggle]', coll);
    const label = btn && $('.coll__toggle-label', btn);
    const expanded = wide.matches ? !coll.classList.contains('is-collapsed') : coll.classList.contains('is-open');
    if (btn) btn.setAttribute('aria-expanded', String(expanded));
    if (label) label.textContent = wide.matches ? (expanded ? label.dataset.labelHide : label.dataset.labelShow) : 'Filters';
  }
  if (coll) {
    if (store.get('ov-filters-collapsed') === '1') coll.classList.add('is-collapsed');
    syncToggle();
    wide.addEventListener ? wide.addEventListener('change', () => { closeColl(); syncToggle(); }) : wide.addListener(() => { closeColl(); syncToggle(); });
    coll.addEventListener('click', (e) => {
      if (e.target.closest('[data-coll-toggle]')) {
        if (wide.matches) {
          coll.classList.toggle('is-collapsed');
          store.set('ov-filters-collapsed', coll.classList.contains('is-collapsed') ? '1' : '0');
        } else {
          coll.classList.add('is-open');
          const bd = $('.coll__backdrop', coll); if (bd) bd.hidden = false;
          document.body.style.overflow = 'hidden';
          const side = $('[data-coll-side]', coll);
          if (side) { side.setAttribute('tabindex', '-1'); side.focus({ preventScroll: true }); }
        }
        syncToggle();
        return;
      }
      if (e.target.closest('[data-coll-close]')) closeColl();
    });
    /* Sort select lives outside the form (form="CollForm") */
    const sort = $('[data-sort]', coll);
    if (sort && sort.form) {
      sort.addEventListener('change', () => {
        const params = new URLSearchParams(new FormData(sort.form));
        for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
        window.location.search = params.toString();
      });
    }
  }

  /* Any leftover dropdown (details.filter / .js-dropdown): close on outside click */
  document.addEventListener('click', (e) => {
    $$('details.filter[open], details[data-dropdown][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (d.matches && d.matches('details.filter') && d.open) $$('details.filter[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
  }, true);

  /* Horizontal rails: arrow buttons */
  function initRails(scope = document) {
    $$('[data-rail]', scope).forEach((rail) => {
      if (rail.dataset.railReady) return;
      rail.dataset.railReady = '1';
      const sec = rail.closest('section') || rail.parentElement;
      const prev = $('[data-rail-prev]', sec);
      const next = $('[data-rail-next]', sec);
      const step = () => Math.max(rail.clientWidth * 0.85, 240);
      const sync = () => {
        if (prev) prev.disabled = rail.scrollLeft < 8;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
        const nav = prev && prev.parentElement;
        if (nav) nav.style.visibility = rail.scrollWidth > rail.clientWidth + 8 ? '' : 'hidden';
      };
      if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }
  initRails();
  /* "You may also like" is fetched after load: watch for it */
  const related = $('[data-related]');
  if (related && 'MutationObserver' in window) new MutationObserver(() => initRails(related)).observe(related, { childList: true, subtree: true });

  /* Bottom sheets (Shop) */
  function closeSheets() {
    $$('.sheet:not([hidden])').forEach((s) => { s.hidden = true; });
    $$('[data-sheet-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-sheet-open]');
    if (opener) {
      const sheet = document.getElementById(opener.dataset.sheetOpen);
      if (!sheet) return;
      const willOpen = sheet.hidden;
      closeSheets();
      if (willOpen) {
        sheet.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        const p = $('.sheet__panel', sheet); if (p) p.focus();
      }
      return;
    }
    if (e.target.closest('[data-sheet-close]')) closeSheets();
    if (e.target.closest('.sheet a')) closeSheets();
  });

  /* Floating cart pill: show when the cart has items */
  const pill = $('[data-cart-pill]');
  if (pill) {
    const countEl = $('[data-cart-count-text]', pill);
    const sync = () => { pill.hidden = !(Number((countEl && countEl.textContent) || 0) > 0); };
    if (countEl && 'MutationObserver' in window) new MutationObserver(sync).observe(countEl, { childList: true, characterData: true, subtree: true });
    sync();
  }
})();
